import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import handleKeyPress from '../../common/handleKeyPress';
import * as Styled from './styles';

const Toggle = ({ initialValue, onToggle }) => {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        setValue(initialValue);
    }, [initialValue]);

    const onToggleClick = () => {
        setValue(!value);
        onToggle(value);
    };

    return (
        <Styled.ToggleContainer
            data-test-id="toggle-div"
            onClick={() => onToggleClick()}
            onKeyDown={(e) => handleKeyPress(e, onToggleClick)}
            tabIndex={0}
        >
            <Styled.ToggleBar value={value}>
                <Styled.ToggleSphere data-test-id="toggle-sphere" value={value} />
                <Styled.ToggleBarText value={value}>{value ? 'ON' : 'OFF'}</Styled.ToggleBarText>
            </Styled.ToggleBar>
        </Styled.ToggleContainer>
    );
};

Toggle.propTypes = {
    onToggle: PropTypes.func.isRequired,
    initialValue: PropTypes.bool,
};

Toggle.defaultProps = {
    initialValue: false,
};

export default Toggle;
